<template>
<div v-if="!isMobile">
   <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>
 <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">

  <v-card class="mx-auto elevation-19">
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="airQuality"
      :search="search"
    >
    <template v-slot:[`item.timestamp`]="{ item }">
      {{ formatDate(item.timestamp) }}
    </template>
     <template v-slot:[`item.age`]="{ item }">
      <span v-if='item.age == "Close"' style="color:red">{{item.age}}</span>
      <span v-if='item.age == "Open"' style="color:green">{{item.age}}</span>
    </template>
      <template v-slot:[`item.name`]="{ item }">
      <span v-if='item.name == "Close"' style="color:red">{{item.name}}</span>
      <span v-if='item.name == "Open"' style="color:green">{{item.name}}</span>
    </template>
    <template v-slot:[`item.co2`]="{ item }">
     {{item.co2}} ppm
    </template>
    <template v-slot:[`item.temp`]="{ item }">
     {{item.co2}} °C
    </template>
    <template v-slot:[`item.humid`]="{ item }">
     {{item.humid}} %RH
    </template>
    <template v-slot:[`item.location`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">Server Room 2</span>
     <span v-if="item.location[0].location == 'Cheng Room'">Server Room 1</span>
     <span v-if="item.location[0].location == 'Production'">Server Room 5</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'">Server Room 4</span>
     <span v-if="item.location[0].location == 'JM Room'">Server Room 3</span>
    </template>
  <template v-slot:[`item.name`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">Staff Token 1</span>
     <span v-if="item.location[0].location == 'Cheng Room'">Staff Token 2</span>
     <span v-if="item.location[0].location == 'Production'">Windows Back Left 1</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">Windows Back Left 2</span>
     <span v-if="item.location[0].location == 'JM Room'">Windows Back Right 1</span>
    </template>
    <template v-slot:[`item.status`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'" style="color:green">Active</span>
     <span v-if="item.location[0].location == 'Cheng Room'" style="color:green">Active</span>
     <span v-if="item.location[0].location == 'Production'" style="color:blue">Idling</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'" style="color:green">Active</span>
     <span v-if="item.location[0].location == 'JM Room'" style="color:blue">Idling</span>
    </template>
    <template v-slot:[`item.battery`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">100%</span>
     <span v-if="item.location[0].location == 'Cheng Room'">100%</span>
     <span v-if="item.location[0].location == 'Production'">99%</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">100%</span>
     <span v-if="item.location[0].location == 'JM Room'">98%</span>
    </template>
     <template v-slot:[`item.timestamp`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Cheng Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Production'">{{formatDate(new Date())}}</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'JM Room'">{{formatDate(item.timestamp)}}</span>
    </template>
     <template v-slot:[`item.type`]>
     <v-icon
      large
      color="blue darken-2"
    >
      mdi-server-security
    </v-icon>
    </template>
</v-data-table>
  </v-card>

   
  </v-col>
</v-row>
 </v-container>
</div>

<div v-else>
 
  <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">

  <v-card class="mx-auto elevation-19">
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="airQuality"
      :search="search"
    >
    <template v-slot:[`item.timestamp`]="{ item }">
      {{ formatDate(item.timestamp) }}
    </template>
     <template v-slot:[`item.age`]="{ item }">
      <span v-if='item.age == "Close"' style="color:red">{{item.age}}</span>
      <span v-if='item.age == "Open"' style="color:green">{{item.age}}</span>
    </template>
      <template v-slot:[`item.name`]="{ item }">
      <span v-if='item.name == "Close"' style="color:red">{{item.name}}</span>
      <span v-if='item.name == "Open"' style="color:green">{{item.name}}</span>
    </template>
    <template v-slot:[`item.co2`]="{ item }">
     {{item.co2}} ppm
    </template>
    <template v-slot:[`item.temp`]="{ item }">
     {{item.co2}} °C
    </template>
    <template v-slot:[`item.humid`]="{ item }">
     {{item.humid}} %RH
    </template>
    <template v-slot:[`item.location`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">Server Room 2</span>
     <span v-if="item.location[0].location == 'Cheng Room'">Server Room 1</span>
     <span v-if="item.location[0].location == 'Production'">Server Room 5</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'">Server Room 4</span>
     <span v-if="item.location[0].location == 'JM Room'">Server Room 3</span>
    </template>
  <template v-slot:[`item.name`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">Staff Token 1</span>
     <span v-if="item.location[0].location == 'Cheng Room'">Staff Token 2</span>
     <span v-if="item.location[0].location == 'Production'">Windows Back Left 1</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">Windows Back Left 2</span>
     <span v-if="item.location[0].location == 'JM Room'">Windows Back Right 1</span>
    </template>
    <template v-slot:[`item.status`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'" style="color:green">Active</span>
     <span v-if="item.location[0].location == 'Cheng Room'" style="color:green">Active</span>
     <span v-if="item.location[0].location == 'Production'" style="color:blue">Idling</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'" style="color:green">Active</span>
     <span v-if="item.location[0].location == 'JM Room'" style="color:blue">Idling</span>
    </template>
    <template v-slot:[`item.battery`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">100%</span>
     <span v-if="item.location[0].location == 'Cheng Room'">100%</span>
     <span v-if="item.location[0].location == 'Production'">99%</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">100%</span>
     <span v-if="item.location[0].location == 'JM Room'">98%</span>
    </template>
    <template v-slot:[`item.timestamp`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Cheng Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Production'">{{formatDate(new Date())}}</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'JM Room'">{{formatDate(item.timestamp)}}</span>
    </template>
     <template v-slot:[`item.type`]>
     <v-icon
      large
      color="blue darken-2"
    >
      mdi-server-security
    </v-icon>
    </template>
</v-data-table>
  </v-card>

   
  </v-col>
</v-row>
 </v-container>
</div>

</template>


<script>
import axios from "axios";
import moment from 'moment';

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Manage Asset',
          disabled: true,
          href: '',
        },
      ],
      values1: moment().subtract(13, "day").startOf("day"),
      values2: moment().subtract(7, "day").endOf("day"),
      headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
          },
          { text: 'Device Type', value: 'type' },
          { text: 'Location', value: 'location' },
          { text: 'Battery', value: 'battery' },
          { text: 'Last Update', value: 'timestamp' },
          { text: 'Status', value: 'status' },
        ],
    loading: true,
    search: '',
    isMobile: true,
    airQuality:[],
    tab: null,
  }),
  mounted() {
    this.loadsCO2();
    this.onResize();
    this.intervalFetchData();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
  intervalFetchData: function () {
    setInterval(() => {    
      this.loadsCo2(),this.loadsWeather()
       }, 300000); 
  },
  onResize() {
      this.isMobile = window.innerWidth < 700;
  },
  formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsCO2: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/air-quality/" + "door" + "/" + this.values1.toDate() + '/'+ this.values2.toDate();
  axios.get(apiURL).then(res => {
    this.airQuality = res.data;
  }).catch(error => {
    console.log(error)
  }).finally(() => this.loading = false);
  },

 updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsCO2();
      this.loading = true;
    },

  updateBoard(){
      this.loadsCO2();
      this.loading = true;
    },

  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

}
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>